import {
    Alert,
    Autocomplete,
    Button,
    ButtonGroup,
    Dialog,
    FormControl, InputLabel, MenuItem,
    Select,
    Snackbar,
    TextField
} from "@mui/material";
import React, {useEffect, useState} from "react";
import SystemNotice from "../authentication/login/_systemNotice";
import UpdateUser from "./UpdateUser";
import {Account} from "../../interfaces/auth_interface";
import {getUser} from "../../services/auth.service";
import UpdateDepartment from "./UpdateDepartment";
import {RunSetUser} from "../../services/account.service";
import {CheckBoxSelection, ComboBoxComponent, Inject, MultiSelectComponent} from "@syncfusion/ej2-react-dropdowns";
import {getUserAuthLevel} from "../../services/getDropdown.service";


interface UserSearchProps {
    SubmitSearch: any
}


const Users: React.FC<UserSearchProps> = ({SubmitSearch}) =>{
    let [userAuth, setUserAuth] = useState<Account>(getUser())
    let [creds, setCreds] = useState<Account>(getUser())
    const [params, setParams] = React.useState({FirstName: "", MI: "", LastName: "", Email: "", UserID: "", DeptName: "", AccountType: "",DeptGroup: "", authLevel: "", status:""})
    const [user, setUser] = React.useState<boolean>(false)
    const [dept, setDept] = React.useState<boolean>(false)
    const [initialRun, setInitialRun] = React.useState<boolean>(false)
    const [alertOpen, setAlertOpen] = React.useState<boolean>(false)
    const [alertText, setAlertText] = React.useState<string>("")
    const [authLevels, setAuthLevels] = React.useState<any>([])


    useEffect(() => {
        if (!initialRun) {
            setInitialRun(true)
            getUserAuthLevel().then((res)=>{setAuthLevels(res)})
            handleSearch()
        }
    });
    
    const handleSearch = () =>
    {
        SubmitSearch(params)
    }

    const createUser = () =>
    {
        setUser(true)
        //window.location.href = ("/admin/UpdateUser?ID=0")
    }
    
    const createDept = () =>
    {
        setDept(true)
    }
    
    const CloseBox = () => {
        setUser(false)
        setDept(false)
        SubmitSearch(params)
    }

    const changeUserActivation = async (person:any) => {
        let p = person
        if (window.confirm("Are You Sure Want To Resend The Login Link To Selected User?")){
            person.EditStatus = "Resend"
            let r = await RunSetUser(person)
            //console.log(r)
            if(r.AnyData.IsValid && r.AnyData.ErrorMessage?.length <= 0)
            {
                setAlertOpen(true)
                setAlertText("Resend Successful")
            }
            else
            {
                alert(r.ErrorMessage)
            }
        }
    }
    
    const handleClear = () => {
        setParams({...params, FirstName: "", MI: "", LastName: "", Email: "", UserID: "", DeptName: "", AccountType: "",DeptGroup: "", authLevel: "", status:""})
    }
    
    return (
        <div className = "ml-5 pl-5 pr-5 pt-5">
            <Snackbar open={alertOpen} autoHideDuration={6000} onClose={ () => { setAlertOpen(false)}}>
                <Alert onClose={ () => { setAlertOpen(false)}} severity="success" sx={{ width: '100%' }}>
                    {setAlertText}
                </Alert>
            </Snackbar>
            <div >
                {creds.AuthLevel === 'S' ? 
                    <div className = "inline">
                        <div className = "inline mr-5">
                            <FormControl sx={{minWidth: 210, maxWidth: 210, minHeight:80}}>
                                <InputLabel id="label">Auth Level</InputLabel>
                                <Select
                                    size = "small"
                                    labelId="label"
                                    value={params.authLevel}
                                    label="Auth Level"
                                    onChange={(e) => {setParams({...params, authLevel: e.target.value})}}
                                >
                                    {authLevels.map((item:any) => (
                                        <MenuItem value={item.Key}>{item.Value}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div className = "inline mr-5">
                            <FormControl sx={{minWidth: 210, maxWidth: 210, minHeight:80}}>
                                <InputLabel id="labelS">Status</InputLabel>
                                <Select
                                    size = "small"
                                    labelId="labelS"
                                    value={params.status}
                                    label="Status"
                                    onChange={(e) => {setParams({...params, status: e.target.value})}}
                                >
                                    <MenuItem value={'Active'}>{'Active'}</MenuItem>
                                    <MenuItem value={'Inactive'}>{'Inactive'}</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                : <></>}
                <div className = "inline mr-5"><TextField margin='none' size={"small"} label="User ID"  value ={params.UserID} onChange={e => setParams({...params, UserID:e.target.value})}/></div>
                <div className = "inline mr-5"><TextField margin='none' size={"small"} label="First Name" value ={params.FirstName} onChange={e => setParams({...params, FirstName:e.target.value})} /></div>
                <div className = "inline mr-5"><TextField margin='none' size={"small"} label="Middle Initial" value ={params.MI} onChange={e => setParams({...params, MI:e.target.value})}/></div>
                <div className = "inline mr-5"><TextField margin='none' size={"small"} label="Last Name" value ={params.LastName} onChange={e => setParams({...params, LastName:e.target.value})}/></div>
                <div className = "inline mr-5"><TextField margin='none' size={"small"} label="Email"  value ={params.Email} onChange={e => setParams({...params, Email:e.target.value})}/></div>
            </div>
             <div className="mt-8 mb-4 flex justify-center">
                 <ButtonGroup variant="outlined" size={"large"} color="inherit">
                     <Button type="submit" onClick={handleSearch}>Search</Button>
                     <Button onClick={handleClear}>CLEAR</Button>
                 </ButtonGroup>
            </div>
            {userAuth.AuthLevel === 'S' || userAuth.AuthLevel === 'M' || userAuth.AuthLevel === 'G' ?
                <span className = {"mr-4"}><Button variant="outlined" size={"small"} type="submit" color="inherit" onClick={createUser}>Add User</Button></span>
                : <></>}
            <Dialog
                open={user}
                maxWidth={'xl'}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <UpdateUser ID={"0"} CloseBox={CloseBox}/>
            </Dialog>
        </div>
    );
}

export default Users;